export const EMAIL_RECOVERY_HELP = 'O e-mail é necessário para recuperar sua senha. Use um endereço ao qual você tenha acesso.';

export const isValidUserEmail = (value) => {
  const email = typeof value === 'string' ? value.trim() : '';
  return email.length <= 254 && /^[^\s<>@]+@[^\s<>@]+\.[^\s<>@]+$/.test(email);
};
